<!-- 
 * @author song
 * @since 2022-04-21
 * @publisher  宏脉信息技术（广州）股份有限公司
 -->
<template>
  <div>
    <header>
      <el-input
        placeholder="券名称"
        suffix-icon="el-icon-search"
        size="mini"
        @blur="searchFn"
        @clear="searchFn"
        v-model="formData.productName"
        style="width: 180px; margin-right: 10px"
      >
      </el-input>
      <el-button-group>
        <el-button size="mini" @click="getDataList">
          发送时间
        </el-button>
        <el-date-picker
          v-model="searchSelectTime"
          size="mini"
          type="daterange"
          :editable="false"
          value-format="yyyy-MM-dd"
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="selectTime"
          :clearable="false"
          style="width: 240px; margin-right: 10px"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-button-group>
    </header>
    <main>
      <el-table
        ref="tableData"
        :summary-method="getSummaries"
        :show-summary="true"
        :data="tableData"
        style="width: 100%"
        height="calc(100vh - 290px)"
        @sort-change="sortChange"
      >
        <el-table-column prop="productName" label="券名称" width="180">
        </el-table-column>
        <el-table-column
          prop="sendTotal"
          label="发送次数"
          sortable="custom"
          width="180"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="clicks"
          label="点击次数"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="clickRate"
          label="打开率"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            {{ scope.row.clickRate }}%
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="couponClaimed"
          label="券领取量"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="couponClaimRate"
          label="券领取率"
          :sort-orders="['descending', 'ascending', null]"
          :sort-method="sortMethod"
        >
          <template slot-scope="scope">
            <!-- {{ scope.row }} -->
            {{ scope.row.couponClaimRate }}%
          </template>
        </el-table-column>
      </el-table>
    </main>
    <footer>
      <Pagination
        v-bind:childMsg="pageparm"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination>
    </footer>
  </div>
</template>

<script>
import { getCouponDataList } from "../../../api/contentCenter/Statistics";
import dayjs from "dayjs";
export default {
  name: "Employee",
  data() {
    return {
      formData: {
        productName: "", //商品名称
        sortField: "", //排序字段  sendTotal-发送次数 clicks-点击次数 clickRate-打开率 salesVolume-商品成交量 couponClaimRate-商品成交率
        sortRule: "", //排序规则  asc-升序 desc-降序
        startTime: dayjs()
          .subtract(29, "days")
          .format("YYYY-MM-DD 00:00:00"), //开始时间
        endTime: dayjs()
          .subtract(0, "days")
          .format("YYYY-MM-DD 23:59:59"), //结束时间
        currentPage: 1, //当前页码
        pageSize: 10, //每页条数
      },
      searchSelectTime: [
        dayjs()
          .subtract(29, "days")
          .format("YYYY-MM-DD 00:00:00"),
        dayjs()
          .subtract(0, "days")
          .format("YYYY-MM-DD 23:59:59"),
      ],
      tableData: [
        //   {
        //     clicks: "1", //点击数
        //     couponClaimed: "20", //券领取量
        //     couponClaimRate: "80.00%", //券领取率
        //     productName: "测试美容项目1", //商品名称
        //     sendTotal: 91, //发送次数
        //     clickRate: "7.00%", //打开率
        //   },
      ],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      pageSizes: [10, 20, 50, 100, 200, 500],
    };
  },
  created() {
    this.getDataList();
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.tableData.doLayout();
    });
  },
  methods: {
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => item[column.property]);
        if (values.length > 0 && index !== 5 && index !== 3) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        } else if (index == 3) {
          sums[index] = `${((sums[2] / sums[1]) * 100 >= 100
            ? 100
            : (sums[2] / sums[1]) * 100
          ).toFixed(2)}%`;
        } else if (index == 5) {
          sums[index] = `${((sums[4] / sums[1]) * 100 >= 100
            ? 100
            : (sums[4] / sums[1]) * 100
          ).toFixed(2)}%`;
        }
      });
      // if (index === 5) {
      //   sums[index] = `${(sums[4] / sums[3]) * 100}%`;
      // }
      console.log("总计XXXXXXXX", data, columns, sums);
      return sums;
    },
    async getDataList() {
      const res = await getCouponDataList(
        this.formData,
        localStorage.getItem("Authorization")
      );
      this.tableData = res.data.rows;
      this.pageparm.total = res.data.total;
      console.log("获取表格的数据结构", res);
    },
    searchFn() {
      this.getDataList();
    },
    selectTime() {
      console.log("时间改变", this.searchSelectTime);
      this.formData.startTime = dayjs(this.searchSelectTime[0]).format(
        "YYYY-MM-DD 00:00:00"
      );
      this.formData.endTime = dayjs(this.searchSelectTime[1]).format(
        "YYYY-MM-DD 23:59:59"
      );
      this.getDataList();
    },
    formatter(row, column) {
      return row.clicks;
    },
    // 排序
    sortMethod() {},
    sortChange(val) {
      if (val.order === "ascending") {
        this.formData.sortRule = "asc";
      } else if (val.order === "descending") {
        this.formData.sortRule = "desc";
      }
      this.formData.sortField = val.prop;
      this.getDataList();
      console.log(
        "排序变化",
        this.formData,
        dayjs()
          .subtract(29, "days")
          .format("YYYY-MM-DD hh:mm:ss")
      );
    },
    // 分页回调
    callBack(parm) {
      console.log("分页器XXXX", parm);
      this.formData.currentPage = parm.currentPage;
      this.formData.pageSize = parm.pageSize;
      this.getDataList();
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-table {
  overflow: visible !important;
  .has-gutter{
    font-weight: 700;
  }
}
</style>
